<template>
  <div class="sub-page">
    <Header/>
    <div class="main">
      <Agency />
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from '@district/components/common/Header.vue'
import Agency from '@daoba-match/components/center/Agency.vue'
import Footer from '@district/components/common/Footer.vue'
export default {
  components: {
    Header,
    Agency,
    Footer
  }
}
</script>
<style lang="scss" scoped>
.sub-page{
  width: 100%;
  .main{
    width: 100%;
    padding-top: 100px;

  }
}
</style>



// WEBPACK FOOTER //
// src/district/views/icenter/Agency.vue